import { projectsData } from "../Components/ProjectBlueprint";
import ProjectHeader from "../Components/ProjectHeader";
import GifShowcase from "../Components/GifShowcase";
import Picture from "../Components/ShowcasePicture";
import UnityLogo from "../img/Icons/unityIcon.png";
import BlenderLogo from "../img/Icons/blenderIcon.png";
import ItchIcon from "../img/Icons/ItchIcon.png";
import { itchPages } from "../data/itchPages";

export default function ProjectPage({ id }) {
  const project = projectsData.find((p) => p.id === id);

  if (!project) {
    return <div>Project not found</div>;
  }

  const itchPageUrl = itchPages[project.id];

  const technologyIcons = project.technologies
    .map((technology) => {
      switch (technology) {
        case "Unity":
          return UnityLogo;
        case "Blender":
          return BlenderLogo;
        default:
          return null;
      }
    })
    .filter((icon) => icon !== null);

  return (
    <div className="sProjectContainer">
      <h1 className="projectPageTitle">{project.title}</h1>
      <ProjectHeader
        description={project.description}
        video={project.video}
        vidthumbnail={project.videoThumbnail}
        status={project.status}
        duration={project.duration}
        technologiesIcons={technologyIcons}
        names={project.technologies}
        showcaseVideo={project.showcaseVideo}
      />
      {itchPageUrl && (
        <a
          className="itchProjectLink"
          href={itchPageUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={ItchIcon} alt="" />
          <span>View on itch.io</span>
        </a>
      )}
      <div>
        {project.proudDescriptions && project.proudDescriptions.length > 0 && (
          <div>
            <h1>I am proud of...</h1>
          </div>
        )}
      </div>
      <div className="sProjectInformationHolders">
        {project.gifs &&
          project.gifs.length > 0 &&
          project.gifs.map((showcase, index) => (
            <GifShowcase
              key={`${project.id}-${showcase.title}-${index}`}
              title={showcase.title}
              description={project.proudDescriptions[index]}
              gif={showcase.src}
              objectFit={project.objectFit}
            />
          ))}
      </div>
      {project.images && project.images.length > 0 && (
        <>
          <div style={{ marginTop: "50px" }}>
            <h1>Gallery</h1>
          </div>
          <div className="pictureGallery">
            {project.images.map((image, index) => (
              <Picture
                key={index}
                picture={image.src}
                altText={image.altText}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
